module.exports = __webpack_public_path__ + "static/media/whiteArrow.9c808470.svg";